/*
 * La Boutique du Mocassin — passe de profondeur (20/08/2026)
 *
 * Ne fait qu'une chose : écrire la position du curseur dans des
 * variables CSS (--lx-rx / --lx-ry sur une carte, --lx-px / --lx-py sur
 * le hero). Tout le rendu vit dans luxe-3d.css. Retirer ce fichier
 * laisse les ombres et la mise en page intactes.
 *
 * DÉLÉGATION, pas d'écouteur par carte. Une page collection porte
 * jusqu'à 24 cartes, et Dawn REMPLACE toute la grille à chaque filtre
 * de facette : des écouteurs posés élément par élément disparaîtraient
 * au premier filtre, sans erreur et sans qu'on le voie.
 */
(function () {
  'use strict';

  var TILT = 5; // doit rester égal à --lx-tilt dans luxe-3d.css

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function actif() {
    return fine.matches && !calm.matches;
  }

  var carteCourante = null; // .card--card actuellement inclinée
  var heroCourant = null;
  var enAttente = null;
  var frame = 0;

  function ecrire() {
    frame = 0;
    var t = enAttente;
    if (!t) return;
    enAttente = null;
    t.el.style.setProperty(t.nx, t.x);
    t.el.style.setProperty(t.ny, t.y);
  }

  function planifier(el, nx, x, ny, y) {
    enAttente = { el: el, nx: nx, x: x, ny: ny, y: y };
    if (!frame) frame = requestAnimationFrame(ecrire);
  }

  function rendre(el, noms) {
    if (!el) return;
    el.style.removeProperty(noms[0]);
    el.style.removeProperty(noms[1]);
  }

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!actif()) return;

      /* ---- cartes produit ---- */
      var wrapper = e.target.closest ? e.target.closest('.product-card-wrapper') : null;
      var carte = wrapper ? wrapper.querySelector('.card--card') : null;
      if (carte !== carteCourante) {
        rendre(carteCourante, ['--lx-rx', '--lx-ry']);
        carteCourante = carte;
      }
      if (carte) {
        var rc = wrapper.getBoundingClientRect();
        var cx = (e.clientX - rc.left) / rc.width; // 0 → 1
        var cy = (e.clientY - rc.top) / rc.height;
        planifier(
          carte,
          '--lx-ry',
          ((cx - 0.5) * 2 * TILT).toFixed(2) + 'deg',
          '--lx-rx',
          ((0.5 - cy) * 2 * TILT).toFixed(2) + 'deg',
        );
        return;
      }

      /* ---- hero ---- */
      var hero = e.target.closest ? e.target.closest('.hero-section') : null;
      if (hero !== heroCourant) {
        rendre(heroCourant, ['--lx-px', '--lx-py']);
        heroCourant = hero;
      }
      if (hero) {
        var rh = hero.getBoundingClientRect();
        planifier(
          hero,
          '--lx-px',
          (((e.clientX - rh.left) / rh.width - 0.5) * 2).toFixed(3),
          '--lx-py',
          (((e.clientY - rh.top) / rh.height - 0.5) * 2).toFixed(3),
        );
      }
    },
    { passive: true },
  );

  /* Le curseur qui quitte la fenêtre ne déclenche aucun pointermove :
     sans ceci, la dernière carte survolée resterait inclinée. */
  function toutRendre() {
    rendre(carteCourante, ['--lx-rx', '--lx-ry']);
    rendre(heroCourant, ['--lx-px', '--lx-py']);
    carteCourante = null;
    heroCourant = null;
  }

  document.addEventListener('pointerleave', toutRendre);
  window.addEventListener('blur', toutRendre);
  calm.addEventListener('change', toutRendre);
})();
